export default "__VITE_ASSET__DFYbklAn__"